import React from "react";
import Newsletter from "./Newsletter";
// import { AboutImg } from "../Constant/Index";
const AboutComponent = (props) => {
    return (
        <>
            <section className="about-text-section">
                <div className="container">
                    <div className="about-text-start">
                        <div className="col-lg-11 mx-auto">
                            <div className="row">
                                <div className="col-sm-6 pe-lg-5" data-aos="fade-right" data-aos-duration="1300">
                                    <figure className="with-bg ">
                                        <img src={props.image} className="w-100 with-radius" alt="" />
                                    </figure>
                                </div>
                                <div className="col-sm-6 ps-lg-0 d-flex flex-column justify-content-center mt-5 mt-md-0" data-aos="fade-left" data-aos-duration="1300">
                                    <div className="text-here">
                                        <h4 className="md-heading mb-4">{props.name}</h4>
                                        <p className="text" dangerouslySetInnerHTML={{ __html: props.text}} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Newsletter />
        </>
    )
}
export default AboutComponent;